import { createSlice } from "@reduxjs/toolkit";
import { paymentUID } from "../../services/axiosConfig";

const storedTokens = Number(localStorage.getItem("available_tokens")) || 0;

const tokenSlice = createSlice({
  name: "token",
  initialState: {
    loading: false,
    error: false,
    tokenRemaining: storedTokens,
    isCreateTokenModalOpen: false,
    isPaymentPopupOpen: false,
    tokenDetail: {
      oid: "",
      uid: paymentUID,
      transactionTime: "",
    },
    paymentGTMDetail: {
      oid: "",
      uid: paymentUID,
      tokenQuantity: "",
      currency: "",
      value: "",
    },
  },
  reducers: {
    updateGTMDDetail: (state, action) => {
      const { newToken, currency, orderId } = action.payload;
      state.paymentGTMDetail = {
        ...state.paymentGTMDetail,
        oid: orderId,
        tokenQuantity: newToken,
        currency,
      };
    },
    updateLoadingStatus: (state, action) => {
      state.loading = action.payload;
    },
    updateErrStatus: (state) => {
      state.loading = false;
      state.error = true;
    },
    createTokenModalOpen: (state, action) => {
      state.isCreateTokenModalOpen = action.payload;
    },
    initialToken: (state, action) => {
      state.tokenRemaining = action.payload;
      localStorage.setItem("available_tokens", state.tokenRemaining);
    },
    updateSuccessToken: (state, action) => {
      state.tokenRemaining = state.tokenRemaining + action.payload.newToken;
      localStorage.setItem("available_tokens", state.tokenRemaining);
    },
    tokenUpdate: (state, action) => {
      const { newToken, orderId, transactionTime } = action.payload;

      // state.tokenRemaining += newToken;

      localStorage.setItem("available_tokens", state.tokenRemaining);

      state.tokenDetail = {
        ...state.tokenDetail,
        oid: orderId,
        transactionTime,
      };
    },

    tokenRedeemUpdate: (state, action) => {
      state.tokenRemaining = state.tokenRemaining - action.payload;
      localStorage.setItem("available_tokens", state.tokenRemaining);
    },
    updatePaymentPopup: (state, action) => {
      state.isPaymentPopupOpen = action.payload;
    },
    updateTokenError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const {
  updateLoadingStatus,
  initialToken,
  updateErrStatus,
  tokenUpdate,
  createTokenModalOpen,
  tokenRedeemUpdate,
  updatePaymentPopup,
  updateSuccessToken,
  updateTokenError,
  updateGTMDDetail
} = tokenSlice.actions;

export default tokenSlice.reducer;
